import { Injectable, EventEmitter } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntakeService {
  
  //event emitter for save social history
  invokeSaveSocialHistory = new EventEmitter();       
  subsSaveSocialHistory: Subscription;
  
  //event emitter for next step in intake form
  invokeNextStepSurgicalHistory = new EventEmitter();       
  subsNextStepSurgicalHistory: Subscription;
  
  //event emitter for next step in intake form
  invokeNoKnown = new EventEmitter();       
  subsNoKnown: Subscription;
  
  constructor(private genericService: GenericUtilityService) { }
  
  onSaveSocialHistory()
  {
    this.invokeSaveSocialHistory.emit();
  }
  
  
  invokeNextStepSurgical = new EventEmitter();       
  subsNextStepSurgical: Subscription;
  onNextStepSurgical()
  {
    this.invokeNextStepSurgical.emit();
  }
  onNextStepSurgicalHistory()
  {
    this.invokeNextStepSurgicalHistory.emit();
  }
  onNoKnown()
  {
    this.invokeNoKnown.emit();
  }
  
  subsSavePastHospHXForm: Subscription;
  invokeSavePastHospHX = new EventEmitter(); 
  onSavePastHospHX()
  {
    this.invokeSavePastHospHX.emit();
  }
  
  getCheckinFormSetting(PatientAccount: any, PracticeCode: any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetCheckinFormSettings?PatientAccount="+PatientAccount+"&PracticeCode=" + PracticeCode);
  }
  GetIntakeForms(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetIntakeForms?PracticeCode=" + PracticeCode + '&PatientAccount=' + PatientAccount);
  }
}
